// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"61f913909056c5448a21","655":"14fecc710d3b995502f5"}[chunkId] + ".js";
};